import { borderRadius } from '@atlaskit/media-ui';
import { getSelectionStyles, SelectionStyle, hideNativeBrowserTextSelectionStyles } from '@atlaskit/editor-shared-styles/selection';

/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */
export var getSelectedBorderStyle = function getSelectedBorderStyle(_ref) {
  var selected = _ref.selected;
  return "\n    ".concat(hideNativeBrowserTextSelectionStyles, "\n\n    &::after {\n      content: '';\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      box-sizing: border-box;\n      pointer-events: none;\n      ").concat(borderRadius, "\n      ").concat(selected ? getSelectionStyles([SelectionStyle.Border]) : '', "\n    }\n  ");
};